import { BasicVertexEvent } from './BasicVertexEvent';
export class LowBendVertexEvent extends BasicVertexEvent {
    constructor(obstacle, p) {
        super(obstacle, p);
    }
}
export class HighBendVertexEvent extends BasicVertexEvent {
    constructor(obstacle, p) {
        super(obstacle, p);
    }
}
export class CloseVertexEvent extends BasicVertexEvent {
    constructor(obstacle, p) {
        super(obstacle, p);
    }
}
//# sourceMappingURL=MiscVertexEvents.js.map